import React from "react";
import Hero from "../components/Hero.jsx";
import AboutUs from "../components/AboutUs.jsx";
import RecentActivities from "../components/RecentActivities.jsx";
import ImpactStats from "../components/ImpactStats.jsx";
import Programs from "../components/Programs.jsx";
import CTA from "../components/CTA.jsx";
import FAQ from "../components/FAQ.jsx";
import ContactUs from "../components/ContsctUs.jsx";
import Footer from "../components/Footer.jsx";

const Home = () => {
    return (
        <div>
            <Hero />
            <AboutUs />
            <RecentActivities />
            <ImpactStats />
            <Programs />
            <CTA />
            <FAQ />
            <ContactUs />
            <Footer />
        </div>
    );
};

export default Home;
